import React from "react";
import Select from "react-select";

export default function SelectBox({ ...props }) {
  return (
    <Select
      className="selectBox"
      components={{ IndicatorSeparator: () => null }}
      styles={{ option: (base) => ({ ...base, color: "#000" }) }}
      {...props}
    />
  );
}
